import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "instructions-setup" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "header-setup header-1" }, "How Opt Works", -1 /* HOISTED */)
const _hoisted_3 = { class: "instructions-container" }
const _hoisted_4 = { class: "subheader" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("1. Set Your Price")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon chevron-down chevron",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "8 8 32 32"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m24 30.75-12-12 2.15-2.15L24 26.5l9.85-9.85L36 18.8Z" })
], -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "description"
}
const _hoisted_9 = { class: "subheader" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("2. Send an Invite")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon chevron-down chevron",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "8 8 32 32"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m24 30.75-12-12 2.15-2.15L24 26.5l9.85-9.85L36 18.8Z" })
], -1 /* HOISTED */)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 0,
  class: "description"
}
const _hoisted_14 = { class: "subheader" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("3. Have a (better) Meeting")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon chevron-down chevron",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "8 8 32 32"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m24 30.75-12-12 2.15-2.15L24 26.5l9.85-9.85L36 18.8Z" })
], -1 /* HOISTED */)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 0,
  class: "description"
}
const _hoisted_19 = { class: "subheader" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("4. Pay or Get Paid")
const _hoisted_21 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon chevron-down chevron",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "8 8 32 32"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m24 30.75-12-12 2.15-2.15L24 26.5l9.85-9.85L36 18.8Z" })
], -1 /* HOISTED */)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 0,
  class: "description"
}
const _hoisted_24 = { class: "tmp-link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: _normalizeClass(["outline", {isActive:$setup.stage === $setup.StepStage.STEP1}]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.updateStage(1)))
        }, [
          _hoisted_5,
          _createElementVNode("span", {
            class: _normalizeClass(["chevy", {isActive:$setup.stage != $setup.StepStage.STEP1}])
          }, _hoisted_7, 2 /* CLASS */)
        ], 2 /* CLASS */),
        ($setup.stage === $setup.StepStage.STEP1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Make and offer by deciding how much you would pay or charge for 15, 30, 60 minutes."))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          class: _normalizeClass(["outline", {isActive:$setup.stage === $setup.StepStage.STEP2}]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.updateStage(2)))
        }, [
          _hoisted_10,
          _createElementVNode("span", {
            class: _normalizeClass(["chevy", {isActive: $setup.stage != $setup.StepStage.STEP2}])
          }, _hoisted_12, 2 /* CLASS */)
        ], 2 /* CLASS */),
        ($setup.stage === $setup.StepStage.STEP2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, "Opt generates a link you can directly share in an email or text communicating respect and avoiding the awkward conversation around paying for time."))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("button", {
          class: _normalizeClass(["outline", {isActive:$setup.stage === $setup.StepStage.STEP3}]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.updateStage(3)))
        }, [
          _hoisted_15,
          _createElementVNode("span", {
            class: _normalizeClass(["chevy", {isActive:$setup.stage != $setup.StepStage.STEP3}])
          }, _hoisted_17, 2 /* CLASS */)
        ], 2 /* CLASS */),
        ($setup.stage === $setup.StepStage.STEP3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, "Opt syncs with your Google or Outlook calendar, allowing the other party to schedule without the back-and-forth. When both sides choose to put a value ON time, meeting are better."))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("button", {
          class: _normalizeClass(["outline", {isActive:$setup.stage === $setup.StepStage.STEP4}]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.updateStage(4)))
        }, [
          _hoisted_20,
          _createElementVNode("span", {
            class: _normalizeClass(["chevy", {isActive:$setup.stage != $setup.StepStage.STEP4}])
          }, _hoisted_22, 2 /* CLASS */)
        ], 2 /* CLASS */),
        ($setup.stage === $setup.StepStage.STEP4)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, "After both sides attend the meeting, funds are transferred. With Opt as your trusted third party you don't have to worry about chasing down money or sending invoices hoping they'll get paid."))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("a", {
        class: "next",
        onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.emit('progress')))
      }, "Next Page")
    ])
  ]))
}